import {Component, OnInit} from '@angular/core';
import {DataProviderService, ITeamMember, IPartner} from '../shared/data-provider.service';
import {IList} from 'linq-collections/build/src/Collections';
import {Config} from '../shared/config';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {
  constructor(private _dataProviderService: DataProviderService) {
  }

  teamMembers: IList<ITeamMember>;
  teamDeveloperMembers: IList<ITeamMember>;
  teamDesignerMembers: IList<ITeamMember>;

  get separateGroups(): boolean {
    return Config.teamGroupsShownSeparated;
  }

  ngOnInit(): void {
    this._dataProviderService.getTeamMembers()
      .subscribe(
        teamMembers => {
          this.teamMembers = teamMembers;
          this.teamDeveloperMembers = teamMembers.where(tm => tm.group === 'Developer').toList();
          this.teamDesignerMembers = teamMembers.where(tm => tm.group === 'Designer').toList();
        },
        error => console.log(error) // TODO show on UI
      );
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/team/team.component.ts